import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface CheckMarkIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const CheckMarkIcon: React.FC<CheckMarkIconProps> = ({ strokeWidth = 4, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-checkmark">
    <path
      d="M10 30 L20 40 L40 12"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />
  </SvgIcon>
);

export default CheckMarkIcon;

